import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-payment",
  "use": "icon-payment-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-payment\">\n  <style>\n    #icon-payment .coin {\n    animation: rotate 2s linear infinite;\n    transform-origin: center;\n    }\n    @keyframes rotate {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n    }\n  </style>\n\n  <!-- 外圆 -->\n  <circle cx=\"50\" cy=\"50\" r=\"45\" fill=\"#FF6B00\" stroke=\"#FFFFFF\" stroke-width=\"2\" />\n\n  <!-- 内圆(动画) -->\n  <circle class=\"coin\" cx=\"50\" cy=\"50\" r=\"30\" fill=\"#FFFFFF\" />\n\n  <!-- 货币符号 -->\n  <text x=\"50\" y=\"58\" font-family=\"Arial\" font-size=\"30\" fill=\"#FF6B00\" text-anchor=\"middle\" font-weight=\"bold\">¥</text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/payment.svg
// module id = GDkK
// module chunks = 50